import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import Loader from 'components/Loader';
import { makeStyles } from '@material-ui/core/styles';
import ProductList from 'containers/PrimoProducts/ProductListPage/ProductList';
import styles from './styles.scss';

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% + 10px)',
      margin: '-5px',
    },
  },
  item: {
    [theme.breakpoints.down('sm')]: {
      padding: '0 5px !important',
    },
  },
}));
const QuickShopProducts = ({
  products,
  totalCount,
  loadFilteredProducts,
  areProductsFetching,
  isCostco,
  page,
}) => {
  const classes = useStyles();
  return (
    <Fragment>
      <div className={styles.mainContainer}>
        <Loader loading={areProductsFetching}>
          <div className={styles.mainContainer}>
            <Grid item sm={12} md={9} classes={{ item: classes.item }}>
              <ProductList
                isAuthenticated={false}
                products={products}
                totalCount={totalCount}
                loadFilteredProducts={loadFilteredProducts}
                isLoading={areProductsFetching}
                isProductsInit
                isQuickshop
                isCostco={isCostco}
                page={page}
                isQuickShopPage
              />
            </Grid>
          </div>
        </Loader>
      </div>
    </Fragment>
  );
};

QuickShopProducts.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  totalCount: PropTypes.number,
  loadFilteredProducts: PropTypes.func,
  areProductsFetching: PropTypes.bool,
  isCostco: PropTypes.bool,
  page: PropTypes.string,
};

export default QuickShopProducts;
